import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { finalProjectCoursesFilters } from "../../../../shared/utils/entitiesFiltersUtils";
import Widget from "../../../../shared/components/features/widget/Widget";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import MyCourseItem from "../../../../shared/components/features/courseItem/myCourseItem/MyCourseItem";
import classes from "./FinalProjectCoursesWidget.module.css";

const FinalProjectCoursesWidget = ({ presentation }) => {

    const { texts, lang } = useSelector(state => state.translate);
    const [myInvitationCourse, setMyInvitationCourse] = useState(null);
    const general = useSelector(state => state.uiData?.general);
    const selfLearningCourses = useSelector(state => selectEntitiesByFilters(state, finalProjectCoursesFilters))

    useEffect(() => {
        setMyInvitationCourse({
            ...general.FinalProject.myInvitation[lang],
            link: `${general.FinalProject.baseInvetationLink}/${lang}_${presentation.date}_${presentation.time}.pdf`
        });
    }, [general?.FinalProject?.myInvitation, lang, presentation?.date, presentation?.time, general?.FinalProject?.baseInvetationLink]);

    return (
        <Widget
            color="#FDDB71"
            title={texts.desktop}
            icon={iconsList.myLearning}
            className={classes.DesktopWidget}
        >
            <div className={classes.DesktopContent}>
                <div className={classes.SelfLearningContent}>
                    {selfLearningCourses?.length > 0 &&
                        <div className={classes.CoursesList}>
                            {selfLearningCourses.map((course, index) => (
                                <MyCourseItem
                                    key={course.id || course.externalId || index}
                                    course={course}
                                />
                            ))}
                        </div>
                    }
                    <MyCourseItem
                        course={general?.FinalProject?.presentationLearningCourse?.[lang]}
                    />
                    {presentation?.date && myInvitationCourse && <MyCourseItem course={myInvitationCourse} />}
                </div>
            </div>
        </Widget>
    );
};

export default FinalProjectCoursesWidget;
